import { z } from 'zod';
import { MAX_BOM_ITEMS } from '../bom/constraints.js';
import { optionalUuidString, requiredUuidString } from '../zod-helpers/index.js';
const MAX_STAGED_ENTRIES_PER_COMPONENT = 50;
const closeOutWorkOrderComponentEntryInputSchema = z.object({
    tagId: requiredUuidString('Batch is required.', 'Invalid batch selection.'),
    used: z
        .number()
        .min(0, 'Used quantity must be a non-negative number.')
        .max(1_000_000_000, 'Used quantity must be 1,000,000,000 or less.'),
    scrapped: z
        .number()
        .min(0, 'Scrapped quantity must be a non-negative number.')
        .max(1_000_000_000, 'Scrapped quantity must be 1,000,000,000 or less.'),
});
const closeOutWorkOrderComponentInputSchema = z.object({
    workOrderItemId: requiredUuidString('Component is required.', 'Invalid component selection.'),
    entries: z
        .array(closeOutWorkOrderComponentEntryInputSchema)
        .max(MAX_STAGED_ENTRIES_PER_COMPONENT, `A component can close out at most ${MAX_STAGED_ENTRIES_PER_COMPONENT} staged batches.`)
        .refine((entries) => new Set(entries.map((entry) => entry.tagId)).size === entries.length, {
        message: 'Each batch may only appear once per component declaration.',
    }),
});
// WHY: used + scrapped is not cross-checked against staging here — assertCloseOutDeclaration
// raises CONSUMED_EXCEEDS_STAGED once it can read the staged rows this schema cannot see.
export const closeOutWorkOrderInputSchema = z.object({
    components: z
        .array(closeOutWorkOrderComponentInputSchema)
        .max(MAX_BOM_ITEMS, `A work order can close out at most ${MAX_BOM_ITEMS} components.`)
        .refine((components) => new Set(components.map((component) => component.workOrderItemId)).size ===
        components.length, { message: 'Each component may only appear once in the close-out declaration.' }),
    goodUnits: z
        .number()
        .min(0, 'Good units must be a non-negative number.')
        .max(1_000_000_000, 'Good units must be 1,000,000,000 or less.'),
    scrappedUnits: z
        .number()
        .min(0, 'Scrapped units must be a non-negative number.')
        .max(1_000_000_000, 'Scrapped units must be 1,000,000,000 or less.'),
    outputLocationId: optionalUuidString('Invalid location selection.')
        .nullish()
        .transform((value) => (value == null || value.trim() === '' ? undefined : value))
        .optional(),
    outputLotNumber: z
        .string()
        .trim()
        .max(100, 'Lot number must be 100 characters or fewer.')
        .nullish()
        .transform((value) => (value == null || value === '' ? undefined : value))
        .optional(),
    note: z
        .string()
        .trim()
        .max(1000, 'Note must be 1000 characters or fewer.')
        .nullish()
        .transform((value) => (value == null || value === '' ? undefined : value))
        .optional(),
});
//# sourceMappingURL=close-out-input.js.map